export default __webpack_public_path__ + "static/media/puzzle.0e490c44.svg";